import { createAction, props } from '@ngrx/store';
import { ShipmentQuotation } from './shipment-relations.models';

export const init = createAction(
    '[Portals/Shipments/Relations] Init',
    props<{ shipmentId: string }>()
);

export const loadShipmentQuotation = createAction(
    '[Portals/Shipments/Relations] Load Shipment Quotation',
    props<{ shipmentId: string }>()
);

export const loadShipmentQuotationSuccess = createAction(
    '[Portals/Shipments/Relations] Load Shipment Quotation Success',
    props<{ quotation?: ShipmentQuotation }>()
);

export const loadShipmentQuotationFailure = createAction(
    '[Portals/Shipments/Relations] Load Shipment Quotation Failure',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props<{ error: any }>()
);

export const reset = createAction('[Portals/Shipments/Relations] Reset');
